import React from 'react';
import { Input, Select, Form, Modal, DatePicker, Upload, message, Button, Icon, Col, Row } from 'antd';
import moment from 'moment';

import findOneOrder from "./findOneOrder.js";

const { confirm } = Modal;

const formItemLayout = {
	labelCol: {
		span: 6,
	},
	wrapperCol: {
		span: 14,
	},
}

const formLargeItemLayout = {
	labelCol: {
		span: 3,
	},
	wrapperCol: {
		span: 19,
	},
}

// 根据编号查询
function confirmAction(item, action) {
	// item : order item
	// action 操作函数本身

	// 提示用户已经有相同编号的订单，是否继续
	findOneOrder({ order_no: item.order_no }).then(result => {
		// 获取出status不同的其他订单
		const otherOrders = result.data.filter(order => {
			return order.status !== item.status;
		});
		// 弹出确认框，示意用户是否确认
		if (otherOrders.length > 0) {
			// 
			confirm({
				title: '警告！',
				content: '检测到相同订单编号的订单已被操作，是否仍要进行操作',
				onOk() {
					// 操作
					action();
				},
				onCancel() {
				},
			});
		} else {
			// 操作
			action();
		}
	}).catch(e => {
		message.error('请求错误');
	});
}

const modalMaster = ({ visible, type, item = {}, onOk, onReject, onCancel, form: { getFieldDecorator, validateFields, getFieldsValue,
}, }) => {
	function handleOk() {
		validateFields((err, values) => {

			if (err) { return }

			//如果是 Select InputNumber 作为输入组件；如果不填返回的是 undefined，应该变成 null
			//if(values.cid == item.cid){delete values.cid; } else {if(typeof(values.cid)=="undefined"){values.cid = null; }}	  

			values.status = '同意';
			values.approver = sessionStorage.getItem('user_name');
			values.approver_time = new Date().getTime();
			if (item.id) { values.id = item.id } //如果是变更，item有内容，把id给到values	


			if (!values.is_order_sub && !values.contract_local_url) {
				message.error('未上传合同');
				return
			}

			// 确认
			confirmAction(item, ()=> onOk(values));

		})
	}


	function handleReject() {
		validateFields((err, values) => {

			values.status = '拒绝';
			values.approver = sessionStorage.getItem('user_name');
			values.approver_time = new Date().getTime();

			values.id = item.id;

			// 确认
			confirmAction(item, ()=> onReject(values));
		})
	}

	const modalOpts = {
		title: '审核并推送(会同步推到银行)',
		visible,
		onOk: handleOk,
		onCancel, onReject: handleReject, keyboard: false, maskClosable: false,
		wrapClassName: 'vertical-center-modal',
		width: 520,
		okText: '同意',
		cancelText: '拒绝',
		footer: null
	}



	return (
		<Modal {...modalOpts}>
			<Form layout="horizontal">

				<Form.Item label={'审核意见'} {...formItemLayout} >
					{getFieldDecorator('remarks', {
						initialValue: item.remarks,
					}
					)(
						<Input />
					)}
				</Form.Item>
				<Form.Item hidden={true} label={'业务合同'} {...formItemLayout} >
					{getFieldDecorator('contract_local_url', {
						initialValue: item.contract_local_url,
					}
					)(
						<Input />
					)}
				</Form.Item>

				<Form.Item hidden={true} label={'ID'} {...formItemLayout} >
					{getFieldDecorator('id', {
						initialValue: item.id,
					}
					)(
						<Input />
					)}
				</Form.Item>
				<Form.Item hidden={true} label={'is_order_sub'} {...formItemLayout} >
					{getFieldDecorator('is_order_sub', {
						initialValue: item.is_order_sub,
					}
					)(
						<Input />
					)}
				</Form.Item>

				<Row>
					<Col span={4}  ><Button type='danger' onClick={handleReject}>拒绝</Button></Col>
					<Col span={4} offset={16}  ><Button type='primary' onClick={handleOk}>同意</Button></Col>
					{/* <Modal
						visible={store.sameOrderNoModalVisible}>
						<div>检测到相同订单编号的订单，是否仍要进行操作</div>
						<Row>
							<Col span={4} offset={16}>
								<Button 
								onClick={() => {
									// 关闭确认框
									set({ sameOrderNoModalVisible: false });
								}} 
								type="danger"
								>确认</Button>
							</Col>
							<Col offset={16}>
								<Button>取消</Button>
							</Col>
						</Row>


					</Modal> */}
				</Row>

			</Form>
		</Modal>
	)
}

const ModalRender = Form.create()(modalMaster);


export default ModalRender;
